import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HTTP_CONTEXT_ENDPOINT } from '@core/const';
import { OCC_ENDPOINTS, Ticket } from '@product/const';
import { OccEndpointsService } from '@spartacus/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OccTicketService {
  constructor(
    private http: HttpClient,
    private occEndpointsService: OccEndpointsService,
  ) {}

  createTicket(body: Ticket): Observable<unknown> {
    const url = this.occEndpointsService.buildUrl(OCC_ENDPOINTS.ticket);

    return this.http.post<unknown>(url, body, {
      context: new HttpContext().set(HTTP_CONTEXT_ENDPOINT, OCC_ENDPOINTS.ticket),
    });
  }
}
